import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop.jsx";
import ExactLandingPage from "./pages/ExactLandingPage";
import { AuthProvider } from "./context/AuthContext"; // Import AuthProvider
import { getBookingSlugFromSubdomain } from "./utils/subdomainDetection";
// import { isQueensSubdomain } from "./utils/subdomainUtils";

// Old imports commented out for pivot
// import Login from "./pages/Login";
// import RegisterForm from "./pages/RegistrationForm";
// import SignupOptions from "./components/SignupOptions";
// import LandingPage from "./pages/landingPage";
// import Events from "./pages/Events";
// import EventDetails from "./pages/EventDetails";
// import AcceptBooking from "./components/AcceptBooking";
// import CancelBooking from "./components/CancelBooking";
// import DeclineBooking from "./components/DeclineBooking";
// import SearchPage from "./pages/SearchPage";
// import Providers from "./pages/Providers";
// import QueensUniversityMarketplace from "./pages/queens/QueensUniversityMarketplace";
// import QueensBookingPage from "./pages/queens/QueensBookingPage";
// import Footer from "./components/Footer";
// import ProviderInfo from "./pages/ProviderInfo";
// import AboutUs from "./pages/aboutUs";
import BookingPage from "./pages/BookingPage";
// import CreateEvent from "./pages/createEvent";
// import ManageAccount from "./pages/ManageAccount";
import { ResetPassword } from "./components/ForgotPassword";
// import Unsubscribe from "./components/Unsubscribe";
// import Notifications from "./pages/Notifications";
// import ViewEventPage from "./pages/ViewEventPage";
import Terms from "./pages/terms";
// import Legal from "./pages/legal";
import Privacy from "./pages/privacy";
import CookiePolicy from "./pages/cookie";
import Contact from "./pages/contact";
import WebsiteHyvePlusBundle from "./pages/WebsiteHyvePlusBundle";
// import NewBookingPage from "./pages/NewBookingPage.jsx";
import BookingConfirmationPage from "./pages/BookingConfirmationPage.jsx";
// import BookingPage from "./pages/BookingPage.jsx";
import ReviewPage from "./pages/ReviewPage.jsx";
import CancelBookingPage from "./pages/CancelBookingPage.jsx";
import ScheduleBookingPage from "./pages/ScheduleBookingPage.jsx";
// import ClaimAccount from "./pages/ClaimAccount.jsx";
// import AdminDashboard from "./pages/AdminDashboard.jsx";
// import StripeConfirmationPage from "./pages/StripeConfirmationPage.jsx";
// import InstagramCallback from "./pages/InstagramCallback.jsx";
// import EventDashboard from "./pages/EventDashboard.jsx";

function App() {
  // Detect if we're on a booking slug subdomain (e.g., nailzbydream.uhyve.com)
  const [bookingSlug, setBookingSlug] = useState(null);
  const [subdomainChecked, setSubdomainChecked] = useState(false);

  useEffect(() => {
    const slug = getBookingSlugFromSubdomain();
    if (slug) {
      console.log('[App] Detected booking slug subdomain:', slug);
      setBookingSlug(slug);
    }
    setSubdomainChecked(true);
  }, []);

  // Wait for subdomain check before rendering
  if (!subdomainChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  return (
    <AuthProvider>
      <Router>
        {/* App layout as flexbox */}
        <div className="flex flex-col min-h-screen relative">
          <ScrollToTop />
          {/* Main content area grows to fill available space */}
          <div className="flex-grow App">
            <Routes>
              {/* If on a booking slug subdomain, show booking page at root */}
              {bookingSlug ? (
                <>
                  {/* On subdomain: root IS the booking page */}
                  <Route path="/" element={<BookingPage bookingSlug={bookingSlug} />} />
                  <Route path="/booking-confirmation" element={<BookingConfirmationPage />} />
                  <Route path="/review/:bookingId" element={<ReviewPage />} />
                  <Route path="/cancel-booking/:bookingId" element={<CancelBookingPage />} />
                  <Route path="/terms-of-service" element={<Terms />} />
                  <Route path="/privacy-policy" element={<Privacy />} />
                  <Route path="/cookie-policy" element={<CookiePolicy />} />
                  {/* Catch-all: redirect to root (booking page) */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </>
              ) : (
                <>
                  {/* Main App Routes (no subdomain) */}
                  <Route path="/" element={<ExactLandingPage />} />
                  <Route path="/terms-of-service" element={<Terms />} />
                  <Route path="/privacy-policy" element={<Privacy />} />
                  <Route path="/cookie-policy" element={<CookiePolicy />} />
                  <Route path="/contact" element={<Contact />} />

                  {/* Hidden bundle landing page — only accessible via direct link */}
                  <Route
                    path="/website-hyve-plus-bundle"
                    element={<WebsiteHyvePlusBundle />}
                  />

                  {/* Legacy Queens routes - commented out for pivot */}
                  {/* <Route 
                path="/queens-university" 
                element={<QueensUniversityMarketplace />} 
              />
              <Route 
                path="/queens-university/providers/:typeName" 
                element={<SearchPage />} 
              />
              <Route 
                path="/queens-university/booking/:providerSlug" 
                element={<QueensBookingPage />} 
              /> */}

                  {/* Primary booking route for main app */}
                  <Route
                    path="/booking/:providerUsername"
                    element={<BookingPage />}
                  />

                  {/* Booking Confirmation Page */}
                  <Route
                    path="/booking-confirmation"
                    element={<BookingConfirmationPage />}
                  />

                  {/* Review Page */}
                  <Route
                    path="/review/:bookingId"
                    element={<ReviewPage />}
                  />

                  {/* Cancel Booking Page */}
                  <Route
                    path="/cancel-booking/:bookingId"
                    element={<CancelBookingPage />}
                  />

                  {/* One-time Schedule Booking Page */}
                  <Route
                    path="/one-time/schedule-booking"
                    element={<ScheduleBookingPage />}
                  />


                  <Route
                    path="/reset-password/:token"
                    element={<ResetPassword />}
                  />

                  {/* End of Queens conditional - commented out */}
                  {/* )} */}

                  {/* All other routes commented out for pivot */}
                  {/* <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignupOptions />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/events" element={<Events />} />
              <Route path="/createEvent" element={<CreateEvent />} />
              <Route path="/events/:eventId" element={<EventDetails />} />
              <Route path="/Providers" element={<Providers />} />
              <Route path="/terms-of-service" element={<Terms />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/register" element={<RegisterForm />} />
              <Route
                path="/bookings/:bookingId/accept/:acceptToken"
                element={<AcceptBooking />}
              />
              <Route
                path="/bookings/:bookingId/decline/:declineToken"
                element={<DeclineBooking />}
              />
              <Route
                path="/bookings/:bookingId/cancel/:cancelToken"
                element={<CancelBooking />}
              />
              {/* <Route path="/providers" element={<Providers />} />
              <Route path="/providers/:typeName" element={<SearchPage />} />
              <Route
                path="/providers/hyve/:providerUsername"
                element={<ProviderInfo />}
              /> */}

                  {/* All other routes commented out for pivot */}
                  {/* <Route path="/manage-account" element={<ManageAccount />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/reset-password/:token"
                element={<ResetPassword />}
              />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/view-event" element={<EventDashboard />} />
              <Route
                path="/booking-confirmation"
                element={<BookingConfirmationPage />}
              />
              <Route path="/review/:bookingId" element={<ReviewPage />} />
              <Route path="/claim-account/:id" element={<ClaimAccount />} />
              <Route
                path="/stripe-confirmation"
                element={<StripeConfirmationPage />}
              />
              <Route
                path="/instagram/callback"
                element={<InstagramCallback />}
              /> */}
                </>
              )}
            </Routes>
          </div>
          {/* Footer commented out for pivot page, WaitlistPage has its own footer */}
          {/* <Footer /> */}
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
